import React, { useState } from 'react'
import { useQuery, useMutation } from '@apollo/client'
import { DataTable } from '../table/DataTable'
import VoucherApprovalsTable from './VoucherApprovalsTable'
import { Button, TextField } from '@mui/material'
import { UPDATE_VOUCHER, GET_VOUCHERS_ALL } from '../Vouchers/gql'
import { APPROVE_VOUCHER, PAID_VOUCHER } from '../Inbox/gql'
import { ColumnDef } from '@tanstack/react-table'
import { VoucherApprovalStageStatus } from '../../types'
import { toast } from 'react-toastify'

const VouchersManagement = () => {
  const { data, loading, error, refetch } = useQuery(GET_VOUCHERS_ALL)
  const [updateVoucher] = useMutation(UPDATE_VOUCHER)
  const [approveStage] = useMutation(APPROVE_VOUCHER)
  const [paidStage] = useMutation(PAID_VOUCHER)

  const [editingVoucherId, setEditingVoucherId] = useState<string | null>(null)
  const [formData, setFormData] = useState<any>({})

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error: {error.message}</p>

  const handleEditClick = (voucher: any) => {
    setEditingVoucherId(voucher.id)
    setFormData({ ...voucher })
  }

  const handleSaveClick = async (id: string) => {
    await updateVoucher({
      variables: { id, input: formData },
    })
    setEditingVoucherId(null)
    refetch()
  }

  const handleApprove = async (
    voucherId: string,
    stageId: string,
    comment?: string,
    isPaymentStage?: boolean
  ) => {
    try {
      isPaymentStage
        ? await paidStage({
            variables: {
              input: {
                voucher_id: voucherId,
                paid_by_amin: new Date().toISOString(),
                payment_reference: comment || null,
              },
            },
            refetchQueries: [{ query: GET_VOUCHERS_ALL }],
          })
        : await approveStage({
            variables: {
              input: {
                voucherId: voucherId,
                status: VoucherApprovalStageStatus.APPROVED,
                comment: comment || null,
              },
            },
            refetchQueries: [{ query: GET_VOUCHERS_ALL }],
          })
    } catch (error: any) {
      console.error(error)
      toast.error(
        `Error approving or marking as paid the voucher, ${error.message}`
      )
    }
  }

  const columns: ColumnDef<any>[] = [
    {
      header: 'Reference',
      accessorKey: 'reference_number',
    },
    {
      header: 'Created',
      accessorKey: 'created_at',
      cell: ({ row }) =>
        new Date(row.original.created_at * 1).toLocaleString('sv-SE'),
    },
    {
      header: 'Prepared by',
      accessorKey: 'created_by',
      cell: ({ row }) =>
        `${row.original.created_by.first_name} ${row.original.created_by.last_name}`,
    },
    {
      header: 'Pay to',
      accessorKey: 'pay_to',
      cell: ({ row }) =>
        `${row.original.pay_to.first_name} ${row.original.pay_to.last_name}`,
    },
    {
      header: 'Department',
      accessorKey: 'department',
      cell: ({ row }) => row.original.department.name,
    },
    {
      header: 'State',
      accessorKey: 'state',
    },
    {
      header: 'Total Amount',
      accessorKey: 'total_amount',
      cell: ({ row }) =>
        editingVoucherId === row.original.id ? (
          <TextField
            size="small"
            type="number"
            value={formData.total_amount}
            onChange={(e) =>
              setFormData({
                ...formData,
                total_amount: parseFloat(e.target.value),
              })
            }
          />
        ) : (
          row.original.total_amount
        ),
    },
    // {
    //   header: 'Actions',
    //   cell: ({ row }) =>
    //     editingVoucherId === row.original.id ? (
    //       <Button
    //         variant="contained"
    //         size="small"
    //         onClick={() => handleSaveClick(row.original.id)}
    //       >
    //         Save
    //       </Button>
    //     ) : (
    //       <Button
    //         variant="outlined"
    //         size="small"
    //         onClick={() => handleEditClick(row.original)}
    //       >
    //         Edit
    //       </Button>
    //     ),
    // },
  ]
  return (
    <DataTable
      data={data?.vouchersAll ?? []}
      columns={columns}
      renderSubComponent={(row) => (
        <VoucherApprovalsTable
          voucher={row.original}
          onApprove={handleApprove}
        />
      )}
    />
  )
}

export default VouchersManagement
